import React from "react";
import { Star, Quote } from "lucide-react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Card, CardContent } from "@/components/ui/card";
interface Testimonial {
  id: string;
  name: string;
  role: string;
  company: string;
  content: string;
  rating: number;
  avatar?: string;
}
const testimonials: Testimonial[] = [{
  id: "1",
  name: "Sarah Chen",
  role: "Product Manager",
  company: "TechCorp",
  content: "PromptHub increased my productivity by 10x. The Product Copilot feature alone saves me 5 hours per week on writing PRDs and project specs.",
  rating: 5,
  avatar: ""
}, {
  id: "2",
  name: "Marcus Johnson",
  role: "Marketing Director",
  company: "GrowthLab",
  content: "The quality of prompts is exceptional. I've completely transformed how we create content - from hours to minutes for campaign briefs.",
  rating: 5,
  avatar: ""
}, {
  id: "3",
  name: "Emily Rodriguez",
  role: "UX Designer",
  company: "DesignStudio",
  content: "Having all my favorite prompts saved and organized has streamlined my entire workflow. The ROI on the Pro plan is incredible.",
  rating: 5,
  avatar: ""
}];
const TestimonialsSection: React.FC = () => {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-background">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Loved by 10,000+ Professionals
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">See how Get Prompts is transforming workflows across industries</p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonials.map(testimonial => <Card key={testimonial.id} className="relative overflow-hidden">
              <CardContent className="p-6">
                <div className="absolute top-4 right-4 text-primary/20">
                  <Quote className="h-8 w-8" />
                </div>
                
                <div className="flex items-center gap-1 mb-4">
                  {Array.from({
                length: testimonial.rating
              }).map((_, i) => <Star key={i} className="h-4 w-4 fill-yellow-400 text-yellow-400" />)}
                </div>
                
                <p className="text-muted-foreground mb-6 leading-relaxed">
                  "{testimonial.content}"
                </p>
                
                <div className="flex items-center gap-3">
                  <Avatar className="w-10 h-10">
                    <AvatarFallback className="bg-primary/10 text-primary font-semibold">
                      {testimonial.name.split(' ').map(n => n[0]).join('')}
                    </AvatarFallback>
                    {testimonial.avatar && <AvatarImage src={testimonial.avatar} />}
                  </Avatar>
                  <div>
                    <p className="font-semibold text-sm">{testimonial.name}</p>
                    
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
};
export default TestimonialsSection;